/**
 * Copyright 2025 aendirr
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 */

export const languages = {
  tr: {
    // Site Config
    siteName: "MrsFans Agency",
    siteDescription: "Doğru bir OnlyFans ajansıyla etkileyici sonuçlara ulaşmak",
    
    // Hero Section
    hero: {
      mainHeading: "Doğru bir OnlyFans ajansıyla etkileyici sonuçlara ulaşmak",
      subHeading: "ne kadar kolay olabilir?",
      description: "KAYDIR!",
      ctaButton: {
        text: "Şimdi Başvur!",
        link: "#contact"
      }
    },

    // Slider Messages
    sliderMessages: [
      "DMCA koruması altında güvenli içerik yönetimi",
      "Telif hakları ihlallerine anında müdahale",
      "24/7 içerik koruma ve izleme sistemi",
      "Profesyonel hukuki destek ve danışmanlık",
      "İzinsiz paylaşım durumunda hızlı çözüm",
      "Yasal süreçlerde tam destek garantisi",
      "Kişisel veri güvenliği ve gizlilik koruması",
      "Acil durum hattı 7/24 erişilebilir",
      "%99.9 başarı oranı ile içerik koruması",
      "Hedefli takip ve koruma stratejileri",
      "Detaylı raporlama ve analiz sistemi",
      "Sektörde lider güvenlik teknolojileri"
    ],

    // Grid Section
    gridSection: {
      items: [
        // 1. Kart
        {
          id: 1,
          title: "Profesyonel Yönetim",
          description: "Deneyimli ekibimizle hesabınızı en etkili şekilde yönetiyoruz.",
          icon: "🎯",
          link: "#services",
          videoUrl: "/assets/gridbox/video1.mp4",
          detailedDescription: "OnlyFans hesabınızın profesyonel yönetimi için 7/24 hizmet veren deneyimli ekibimiz, hesabınızın tüm operasyonel süreçlerini optimize eder. Müşteri ilişkilerinden içerik planlamasına, gelir analizinden performans raporlamaya kadar her aşamada yanınızdayız.",
          features: [
            { icon: "fas fa-users", title: "Özel Hesap Yöneticisi", description: "Size özel atanan deneyimli hesap yöneticisi ile kişiselleştirilmiş hizmet" },
            { icon: "fas fa-chart-line", title: "Performans İzleme", description: "Gerçek zamanlı performans takibi ve detaylı analitik raporlama" },
            { icon: "fas fa-comments", title: "Müşteri İletişimi", description: "Profesyonel müşteri hizmetleri ekibi ile 7/24 iletişim yönetimi" },
            { icon: "fas fa-cogs", title: "Hesap Optimizasyonu", description: "Sürekli A/B test ve optimizasyon ile maksimum verimlilik" }
          ],
          benefits: [
            "7/24 profesyonel hesap yönetimi",
            "Gelir artışında %150+ garanti",
            "Günlük performans raporları",
            "Kişiselleştirilmiş strateji geliştirme",
            "Müşteri memnuniyeti garantisi",
            "Hassas veri güvenliği protokolleri"
          ],
          process: [
            { title: "Hesap Analizi", description: "Mevcut hesabınızın detaylı analizini yaparak güçlü ve zayıf yönleri belirleriz" },
            { title: "Strateji Geliştirme", description: "Size özel gelir artırıcı stratejiler geliştirip uygulama planı oluştururuz" },
            { title: "Uygulama & İzleme", description: "Stratejileri uygularken sürekli izleme ve iyileştirme yaparak sonuçları optimize ederiz" },
            { title: "Raporlama & Analiz", description: "Haftalık detaylı raporlarla performansınızı şeffaf şekilde paylaşır, gelecek planlarını yaparız" }
          ],
          stats: [
            { value: "147+", label: "Yönetilen Hesap" },
            { value: "%185", label: "Ortalama Gelir Artışı" },
            { value: "24/7", label: "Destek Hizmeti" },
            { value: "%99.2", label: "Müşteri Memnuniyeti" }
          ]
        },
        // 2. Kart
        {
          id: 2,
          title: "Content Stratejisi",
          description: "Kişiselleştirilmiş içerik stratejileri ile gelir artışı sağlıyoruz.",
          icon: "📈",
          link: "#content",
          videoUrl: "/assets/gridbox/video2.mp4",
          detailedDescription: "Yaratıcı ve etkili içerik stratejileri ile OnlyFans hesabınızın potansiyelini maksimuma çıkarıyoruz. Trend analizi, hedef kitle araştırması ve rekabet analizi ile size özel içerik roadmap'i oluşturuyoruz.",
          features: [
            { icon: "fas fa-calendar-alt", title: "İçerik Takvimi", description: "Haftalık ve aylık içerik planlaması" },
            { icon: "fas fa-trending-up", title: "Trend Analizi", description: "Viral olacak içerik trendlerini önceden tespit" },
            { icon: "fas fa-target", title: "Hedef Kitle", description: "Demografik analiz ve kişiselleştirme" },
            { icon: "fas fa-photo-video", title: "Medya Üretimi", description: "Profesyonel foto/video çekim desteği" }
          ],
          benefits: ["Viral içerik garantisi", "Haftalık içerik planı", "Profesyonel çekim desteği", "Trend takibi", "Rekabet analizi", "ROI optimizasyonu"],
          process: [
            { title: "Marka Analizi", description: "Kişisel markanızı ve güçlü yönlerinizi analiz ederiz" },
            { title: "İçerik Stratejisi", description: "Size özel içerik stratejisi ve takvim oluştururuz" },
            { title: "Üretim Desteği", description: "İçerik üretim sürecinde teknik ve yaratıcı destek sağlarız" },
            { title: "Optimizasyon", description: "Performansa göre sürekli iyileştirme ve güncellemeler yaparız" }
          ],
          stats: [
            { value: "300+", label: "İçerik Stratejisi" },
            { value: "%220", label: "Etkileşim Artışı" },
            { value: "15K+", label: "Üretilen İçerik" },
            { value: "%95", label: "Viral İçerik Oranı" }
          ]
        },
        // 3. Kart
        {
          id: 3,
          title: "Marketing Uzmanlığı",
          description: "Sosyal medya ve dijital pazarlama ile geniş kitlelere ulaşın.",
          icon: "📱",
          link: "#marketing",
          videoUrl: "/assets/gridbox/video4.mp4",
          detailedDescription: "Dijital pazarlama dünyasının uzmanları ile organik büyüme ve ücretli reklam kampanyaları. Instagram, Twitter, TikTok ve diğer platformlarda güçlü varlık oluşturarak takipçi bazınızı exponansiyel olarak büyütüyoruz.",
          features: [
            { icon: "fab fa-instagram", title: "Instagram Marketing", description: "Story, Reels ve post stratejileri" },
            { icon: "fab fa-twitter", title: "Twitter Growth", description: "Viral tweet ve etkileşim artışı stratejileri" },
            { icon: "fab fa-tiktok", title: "TikTok Viralliği", description: "Trend yakalama ve viral içerik üretimi" },
            { icon: "fas fa-bullhorn", title: "Paid Advertising", description: "ROI odaklı ücretli reklam kampanyaları" }
          ],
          benefits: ["Organik takipçi artışı", "Viral içerik üretimi", "Cross-platform strateji", "Influencer iş birlikleri", "Marka güvenilirliği", "Hedefli reklamlar"],
          process: [
            { title: "Mevcut Durum Analizi", description: "Sosyal medya hesaplarınızın detaylı analizini yaparız" },
            { title: "Hedef Belirleme", description: "Büyüme hedeflerini ve target kitlenizi belirleriz" },
            { title: "Kampanya Yürütme", description: "Organik ve ücretli kampanyaları eş zamanlı yürütürüz" },
            { title: "Sonuç Analizi", description: "Kampanya sonuçlarını analiz ederek sürekli optimizasyon yaparız" }
          ],
          stats: [
            { value: "300M+", label: "Ulaşılan Kişi" },
            { value: "%340", label: "Takipçi Artışı" },
            { value: "50+", label: "Viral İçerik" },
            { value: "4.8", label: "ROI Oranı" }
          ]
        }
      ]
    },

    // Bottom Section
    bottomSection: {
      heading: "Kraliçeler Yönetilmez, Yükseltilir.",
      text: "MrsFans Agency senin için çalışır, sen sadece parıldarsın.Kural tanımadan kazan, rakipsiz ol.Lüksü hak ediyorsun, biz onu seninle inşa ediyoruz."
    },

    // Social Media
    socialMedia: {
      instagram: "https://instagram.com/mrfansagency",
      twitter: "https://twitter.com/mrfansagency",
      youtube: "https://youtube.com/@mrfansagency"
    },

    // Navigation
    nav: {
      about: "Hakkımızda",
      models: "Modellerimiz",
      contact: "İletişim",
      apply: "Şimdi Başvur!"
    },

    // Application Modal
    applicationModal: {
      title: "Başvuru Formu",
      firstName: "İsim",
      lastName: "Soyisim",
      phone: "Telefon Numarası",
      email: "E-mail",
      instagram: "Instagram Hesabı (İsteğe bağlı)",
      twitter: "Twitter Hesabı (İsteğe bağlı)",
      reddit: "Reddit Hesabı (İsteğe bağlı)",
      agreeTerms: "Okudum onaylıyorum (",
      privacyPolicy: "Gizlilik Sözleşmesi",
      submit: "Başvur",
      submitting: "Gönderiliyor...",
      success: "Başvurunuz başarıyla alındı! En kısa sürede sizinle iletişime geçeceğiz.",
      error: "Başvuru gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
      close: "Kapat",
      // Validation messages
      firstNameRequired: "İsim gereklidir",
      lastNameRequired: "Soyisim gereklidir",
      phoneRequired: "Telefon numarası gereklidir",
      phoneInvalid: "Geçerli bir telefon numarası giriniz",
      emailRequired: "E-mail gereklidir",
      emailInvalid: "Geçerli bir e-mail adresi giriniz",
      instagramInvalid: "Geçerli bir Instagram kullanıcı adı giriniz",
      twitterInvalid: "Geçerli bir Twitter kullanıcı adı giriniz",
      redditInvalid: "Geçerli bir Reddit kullanıcı adı giriniz",
      termsRequired: "Gizlilik sözleşmesini kabul etmelisiniz"
    },

    // Footer
    footer: {
      description: "Türkiye'nin önde gelen OnlyFans ajansı. Modellerimizin başarısını maksimize etmek için profesyonel hizmet sunuyoruz.",
      quickLinks: "Hızlı Linkler",
      services: "Hizmetlerimiz",
      newsletter: "Bülten",
      newsletterText: "Yeni fırsatlar ve güncellemeler hakkında bilgi alın.",
      newsletterPlaceholder: "E-mail adresiniz",
      privacyPolicy: "Gizlilik Politikası",
      termsOfService: "Kullanım Koşulları",
      dmca: "DMCA",
      copyright: "Tüm hakları saklıdır."
    },

    // Language Switcher
    languageSwitcher: {
      tr: "Türkçe",
      en: "English"
    },

    // Models Section
    modelsSection: {
      heading: "Başarılı Modellerimiz",
      description: "Ajansımızla birlikte başarı hikayesi yazan değerli modellerimizle tanışın. Her biri kendi alanında uzmanlaşarak finansal özgürlüklerine kavuşmuşlardır.",
      clickHint: "Detayları Görüntüle"
    },

    // Model Detail Modal
    modelDetailModal: {
      title: "Model Profili",
      about: "Hakkında",
      experience: "Deneyim (Ay)",
      followers: "Takipçi",
      rating: "Değerlendirme",
      achievements: "Başarıları",
      earningsPerformance: "Gelir Performansı",
      monthlyEarnings: "Aylık Gelir",
      totalEarnings: "Toplam Kazanç",
      growthRate: "Büyüme Oranı",
      socialMediaPlatforms: "Sosyal Medya & Platformlar",
      viewOnlyFansProfile: "OnlyFans Profilini Görüntüle",
      activeModel: "Aktif Model"
    },

    // About Modal
    aboutModal: {
      title: "Hakkımızda",
      closeLabel: "Modalı kapat",
      subtitle: "Türkiye'nin en güvenilir OnlyFans ajansı",
      description: "MrsFans Agency olarak, OnlyFans platformunda başarılı olmak isteyen modellere kapsamlı destek sağlıyoruz. 2021 yılından bu yana sektörde faaliyet gösteren ajansımız, sayısız modelin finansal özgürlüğe kavuşmasına yardımcı olmaktadır.",
      successfulModels: "Başarılı Model",
      totalRevenue: "Toplam Gelir",
      customerSatisfaction: "Müşteri Memnuniyeti",
      supportService: "Destek Hizmeti",
      whatWeOffer: "Neler Sunuyoruz?",
      professionalManagement: "Profesyonel Yönetim",
      professionalManagementDesc: "Deneyimli ekibimizle hesabınızı profesyonelce yönetiyoruz.",
      contentProduction: "İçerik Üretimi",
      contentProductionDesc: "Yaratıcı ve kaliteli içeriklerle kitlenizi büyütüyoruz.",
      marketingStrategy: "Pazarlama Stratejisi",
      marketingStrategyDesc: "Hedefli pazarlama ile gelirlerinizi maksimize ediyoruz.",
      dmcaProtection: "DMCA Koruması",
      dmcaProtectionDesc: "İçeriklerinizi yasadışı paylaşımlara karşı koruyoruz.",
      mission: "Misyonumuz",
      missionText: "Her modelin kendine özgü potansiyelini keşfetmek ve bu potansiyeli en üst seviyeye çıkarmak için gerekli tüm desteği sağlamak. Güvenilir, şeffaf ve sonuç odaklı hizmet anlayışımızla sektörün lideri olmayı hedefliyoruz.",
      values: "Değerlerimiz",
      reliability: "Güvenilirlik",
      transparency: "Şeffaflık",
      successOriented: "Başarı Odaklılık",
      customerSatisfactionValue: "Müşteri Memnuniyeti",
      applyNow: "Şimdi Başvurun"
    },

    // Service Detail Modal
    serviceDetailModal: {
      serviceDescription: "Hizmet Açıklaması",
      featuresAdvantages: "Özellikler & Avantajlar",
      benefitsWeProvide: "Sağladığımız Faydalar",
      processMethodology: "Süreç & Metodoloji",
      performanceStats: "Performans İstatistikleri",
      wantThisService: "Bu Hizmeti Almak İstiyor musunuz?",
      applyNowDesc: "Hemen başvurun ve profesyonel ekibimizle tanışın!",
      applyNow: "Şimdi Başvurun"
    },

    // Models Data
    models: [
      {
        name: 'Lure',
        image: '/assets/models/Alara.jpg',
        description: '2 yıldır ajansımızla çalışan başarılı modelimiz. Sosyal medyada 50K+ takipçi kitlesi.',
        bio: 'Moda ve yaşam tarzı içerikleri ile öne çıkan deneyimli modelimiz. Güçlü sosyal medya varlığı ve yüksek etkileşim oranları ile dikkat çekiyor. İçerik üretiminde yaratıcılığı ve profesyonelliği ile tanınıyor.',
        stats: {
          experience: '24',
          followers: '50K+',
          rating: '4.9'
        },
        achievements: [
          {
            icon: 'fas fa-star',
            title: 'Top Performer',
            description: 'Üst üste 6 ay en yüksek gelir performansı'
          },
          {
            icon: 'fas fa-users',
            title: 'Sosyal Medya Uzmanı',
            description: 'Instagram\'da 50K+ organik takipçi'
          },
          {
            icon: 'fas fa-trophy',
            title: 'Premium Creator',
            description: 'Özel içerik kategorisinde ödül'
          },
          {
            icon: 'fas fa-heart',
            title: 'Fan Favorite',
            description: '%98 müşteri memnuniyet oranı'
          }
        ],
        earnings: {
          monthly: '₺45K',
          total: '₺850K+',
          growth: '+185%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/alara_model',
          twitter: 'https://twitter.com/alara_model',
          tiktok: 'https://tiktok.com/@alara_model',
          onlyfans: 'https://onlyfans.com/alara_model'
        }
      },
      {
        name: 'Riven',
        image: '/assets/models/Gamze.jpg',
        description: 'Profesyonel fotoğrafçılık geçmişi olan deneyimli modelimiz. Aylık geliri 25K+.',
        bio: 'Profesyonel fotoğrafçılık geçmişi sayesinde içerik kalitesi konusunda uzman. Estetik görseller ve sanatsal yaklaşımı ile takipçilerini büyülüyor. Markalarla iş birliği konusunda da başarılı.',
        stats: {
          experience: '18',
          followers: '35K+',
          rating: '4.8'
        },
        achievements: [
          {
            icon: 'fas fa-camera',
            title: 'Fotoğraf Uzmanı',
            description: 'Profesyonel fotoğrafçılık sertifikası'
          },
          {
            icon: 'fas fa-chart-line',
            title: 'Consistent Growth',
            description: 'Son 12 ayda sürekli büyüme'
          },
          {
            icon: 'fas fa-handshake',
            title: 'Brand Partner',
            description: '10+ markla iş birliği'
          },
          {
            icon: 'fas fa-gem',
            title: 'Quality Creator',
            description: 'Yüksek kalite içerik üretimi'
          }
        ],
        earnings: {
          monthly: '₺32K',
          total: '₺580K+',
          growth: '+142%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/gamze_model',
          twitter: 'https://twitter.com/gamze_model',
          tiktok: 'https://tiktok.com/@gamze_model',
          onlyfans: 'https://onlyfans.com/gamze_model'
        }
      },
      {
        name: 'Sirel',
        image: '/assets/models/Aysun.jpg',
        description: 'Fitness ve sağlıklı yaşam içerikleri ile öne çıkan aktif modelimiz.',
        bio: 'Fitness ve wellness alanında uzman. Sağlıklı yaşam tarzını benimseyen takipçilerine ilham veriyor. Antrenman videoları ve beslenme tavsiyelerini de içeriğine dahil ediyor.',
        stats: {
          experience: '15',
          followers: '28K+',
          rating: '4.7'
        },
        achievements: [
          {
            icon: 'fas fa-dumbbell',
            title: 'Fitness Expert',
            description: 'Sertifikalı fitness antrenörü'
          },
          {
            icon: 'fas fa-apple-alt',
            title: 'Wellness Guru',
            description: 'Beslenme ve yaşam koçu'
          },
          {
            icon: 'fas fa-medal',
            title: 'Health Ambassador',
            description: 'Sağlık ve Yaşam Danışmanı'
          },
          {
            icon: 'fas fa-fire',
            title: 'Motivation Master',
            description: 'Yüksek motivasyon içerikleri'
          }
        ],
        earnings: {
          monthly: '₺28K',
          total: '₺420K+',
          growth: '+156%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/aysun_fitness',
          twitter: 'https://twitter.com/aysun_fitness',
          tiktok: 'https://tiktok.com/@aysun_fitness',
          onlyfans: 'https://onlyfans.com/aysun_fitness'
        }
      },
      {
        name: 'Thais',
        image: '/assets/models/Ilgü.jpg',
        description: 'Yaratıcı içerikleri ve özgün tarzı ile dikkat çeken genç yeteneklerimizden.',
        bio: 'Genç ve dinamik kişiliği ile yaş grubundaki takipçilerine hitap ediyor. Yaratıcı içerik fikirleri ve trend yakalama yeteneği ile öne çıkıyor. Özgün tarzını sosyal medyada başarıyla yansıtıyor.',
        stats: {
          experience: '12',
          followers: '42K+',
          rating: '4.9'
        },
        achievements: [
          {
            icon: 'fas fa-lightbulb',
            title: 'Creative Mind',
            description: 'En yaratıcı içerik üreticisi'
          },
          {
            icon: 'fas fa-trending-up',
            title: 'Trend Setter',
            description: 'Viral içerik üretme uzmanı'
          },
          {
            icon: 'fas fa-rocket',
            title: 'Rising Star',
            description: 'En hızlı büyüyen model'
          },
          {
            icon: 'fas fa-paint-brush',
            title: 'Style Icon',
            description: 'Özgün stil ve estetik'
          }
        ],
        earnings: {
          monthly: '₺38K',
          total: '₺460K+',
          growth: '+210%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/ilgu_creative',
          twitter: 'https://twitter.com/ilgu_creative',
          tiktok: 'https://tiktok.com/@ilgu_creative',
          onlyfans: 'https://onlyfans.com/ilgu_creative'
        }
      },
      {
        name: 'Nyrelle',
        image: '/assets/models/Eda.jpg',
        description: 'Ajansımızda alanında uzman olan profesyonel modelimiz.',
        bio: 'Uzun yıllara dayanan modelling deneyimi olan profesyonel. Çeşitli projelerde yer almış, deneyimli yaklaşımı ile ajansımızın köklü modellerinden. Mentorluk da yapıyor.',
        stats: {
          experience: '30',
          followers: '32K+',
          rating: '4.8'
        },
        achievements: [
          {
            icon: 'fas fa-graduation-cap',
            title: 'Mentor',
            description: 'Yeni modellere mentorluk hizmeti'
          },
          {
            icon: 'fas fa-crown',
            title: 'Veteran',
            description: '2+ yıllık başarılı kariyer'
          },
          {
            icon: 'fas fa-shield-alt',
            title: 'Reliable',
            description: 'Güvenilir ve istikrarlı performans'
          },
          {
            icon: 'fas fa-star',
            title: 'Professional',
            description: 'Profesyonel yaklaşım ve deneyim'
          }
        ],
        earnings: {
          monthly: '₺35K',
          total: '₺720K+',
          growth: '+95%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/eda_professional',
          twitter: 'https://twitter.com/eda_professional',
          tiktok: 'https://tiktok.com/@eda_professional',
          onlyfans: 'https://onlyfans.com/eda_professional'
        }
      },
      {
        name: 'Auren',
        image: '/assets/models/Irem.jpg',
        description: 'Ajansımızın en başarılı modellerinden biri. 6 ayda 40K gelir hedefini aştı.',
        bio: 'Kısa sürede büyük başarı elde etmiş yetenekli model. Hedeflerini aşma konusunda kararlı ve azimli. Analitik yaklaşımı ve strateji geliştirme yeteneği ile dikkat çekiyor.',
        stats: {
          experience: '8',
          followers: '38K+',
          rating: '4.9'
        },
        achievements: [
          {
            icon: 'fas fa-target',
            title: 'Goal Crusher',
            description: 'Hedefleri %150 aştı'
          },
          {
            icon: 'fas fa-bolt',
            title: 'Fast Track',
            description: '6 ayda rekor kırma'
          },
          {
            icon: 'fas fa-chart-bar',
            title: 'Data Driven',
            description: 'Analitik yaklaşım uzmanı'
          },
          {
            icon: 'fas fa-diamond',
            title: 'Top Tier',
            description: 'Üst kategori performans'
          }
        ],
        earnings: {
          monthly: '₺52K',
          total: '₺320K+',
          growth: '+280%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/irem_success',
          twitter: 'https://twitter.com/irem_success',
          tiktok: 'https://tiktok.com/@irem_success',
          onlyfans: 'https://onlyfans.com/irem_success'
        }
      }
    ]
  },

  en: {
    // Site Config
    siteName: "MrsFans Agency",
    siteDescription: "Achieve impressive results with the right OnlyFans agency",
    
    // Hero Section
    hero: {
      mainHeading: "Achieve impressive results with the right OnlyFans agency",
      subHeading: "how easy can it be?",
      description: "SCROLL!",
      ctaButton: {
        text: "Apply Now!",
        link: "#contact"
      }
    },

    // Slider Messages
    sliderMessages: [
      "Secure content management under DMCA protection",
      "Immediate intervention in copyright violations",
      "24/7 content protection and monitoring system",
      "Professional legal support and consultation",
      "Quick solution in case of unauthorized sharing",
      "Full support guarantee in legal processes",
      "Personal data security and privacy protection",
      "Emergency hotline accessible 24/7",
      "99.9% success rate in content protection",
      "Targeted tracking and protection strategies",
      "Detailed reporting and analysis system",
      "Leading security technologies in the industry"
    ],

    // Grid Section
    gridSection: {
      items: [
        // 1. Kart
        {
          id: 1,
          title: "Professional Management",
          description: "We manage your account most effectively with our experienced team.",
          icon: "🎯",
          link: "#services",
          videoUrl: "/assets/gridbox/video1.mp4",
          detailedDescription: "Our experienced team providing 24/7 service for professional management of your OnlyFans account optimizes all operational processes of your account. We are with you at every stage from customer relations to content planning, from revenue analysis to performance reporting.",
          features: [
            { icon: "fas fa-users", title: "Dedicated Account Manager", description: "Personalized service with an experienced account manager assigned specifically to you" },
            { icon: "fas fa-chart-line", title: "Performance Monitoring", description: "Real-time performance tracking and detailed analytics reporting" },
            { icon: "fas fa-comments", title: "Customer Communication", description: "24/7 communication management with professional customer service team" },
            { icon: "fas fa-cogs", title: "Account Optimization", description: "Maximum efficiency with continuous A/B testing and optimization" }
          ],
          benefits: [
            "24/7 professional account management",
            "150%+ revenue increase guarantee",
            "Daily performance reports",
            "Personalized strategy development",
            "Customer satisfaction guarantee",
            "Sensitive data security protocols"
          ],
          process: [
            { title: "Account Analysis", description: "We conduct detailed analysis of your existing account to identify strengths and weaknesses" },
            { title: "Strategy Development", description: "We develop revenue-increasing strategies specific to you and create an implementation plan" },
            { title: "Implementation & Monitoring", description: "We continuously monitor and improve while implementing strategies to optimize results" },
            { title: "Reporting & Analysis", description: "We share your performance transparently with weekly detailed reports and make future plans" }
          ],
          stats: [
            { value: "147+", label: "Managed Accounts" },
            { value: "%185", label: "Average Revenue Increase" },
            { value: "24/7", label: "Support Service" },
            { value: "%99.2", label: "Customer Satisfaction" }
          ]
        },
        // 2. Kart
        {
          id: 2,
          title: "Content Strategy",
          description: "Increase revenue with personalized content strategies.",
          icon: "📈",
          link: "#content",
          videoUrl: "/assets/gridbox/video2.mp4",
          detailedDescription: "We maximize the potential of your OnlyFans account with creative and effective content strategies. We create a custom content roadmap for you with trend analysis, target audience research and competitive analysis.",
          features: [
            { icon: "fas fa-calendar-alt", title: "Content Calendar", description: "Weekly and monthly content planning" },
            { icon: "fas fa-trending-up", title: "Trend Analysis", description: "Pre-detect viral content trends" },
            { icon: "fas fa-target", title: "Target Audience", description: "Demographic analysis and personalization" },
            { icon: "fas fa-photo-video", title: "Media Production", description: "Professional photo/video shooting support" }
          ],
          benefits: ["Viral content guarantee", "Weekly content plan", "Professional shooting support", "Trend tracking", "Competitive analysis", "ROI optimization"],
          process: [
            { title: "Brand Analysis", description: "We analyze your personal brand and strengths" },
            { title: "Content Strategy", description: "We create custom content strategy and calendar for you" },
            { title: "Production Support", description: "We provide technical and creative support during content production" },
            { title: "Optimization", description: "We make continuous improvements and updates based on performance" }
          ],
          stats: [
            { value: "300+", label: "Content Strategies" },
            { value: "%220", label: "Engagement Increase" },
            { value: "15K+", label: "Produced Content" },
            { value: "%95", label: "Viral Content Rate" }
          ]
        },
        // 3. Kart
        {
          id: 3,
          title: "Marketing Expertise",
          description: "Reach wide audiences with social media and digital marketing.",
          icon: "📱",
          link: "#marketing",
          videoUrl: "/assets/gridbox/video4.mp4",
          detailedDescription: "Organic growth and paid advertising campaigns with digital marketing experts. We exponentially grow your follower base by creating a strong presence on Instagram, Twitter, TikTok and other platforms.",
          features: [
            { icon: "fab fa-instagram", title: "Instagram Marketing", description: "Story, Reels and post strategies" },
            { icon: "fab fa-twitter", title: "Twitter Growth", description: "Viral tweet and engagement increase strategies" },
            { icon: "fab fa-tiktok", title: "TikTok Virality", description: "Trend catching and viral content production" },
            { icon: "fas fa-bullhorn", title: "Paid Advertising", description: "ROI-focused paid advertising campaigns" }
          ],
          benefits: ["Organic follower growth", "Viral content production", "Cross-platform strategy", "Influencer collaborations", "Brand credibility", "Targeted advertising"],
          process: [
            { title: "Current Situation Analysis", description: "We conduct detailed analysis of your social media accounts" },
            { title: "Goal Setting", description: "We determine growth goals and target audience" },
            { title: "Campaign Execution", description: "We run organic and paid campaigns simultaneously" },
            { title: "Result Analysis", description: "We continuously optimize by analyzing campaign results" }
          ],
          stats: [
            { value: "300M+", label: "Reached People" },
            { value: "%340", label: "Follower Increase" },
            { value: "50+", label: "Viral Content" },
            { value: "4.8", label: "ROI Rate" }
          ]
        }
      ]
    },

    // Bottom Section
    bottomSection: {
      heading: "Queens Are Not Managed, They Are Elevated.",
      text: "MrsFans Agency works for you, you just shine. Win without rules, be unmatched. You deserve luxury, we build it with you."
    },

    // Social Media
    socialMedia: {
      instagram: "https://instagram.com/mrfansagency",
      twitter: "https://twitter.com/mrfansagency",
      youtube: "https://youtube.com/@mrfansagency"
    },

    // Navigation
    nav: {
      about: "About",
      models: "Our Models",
      contact: "Contact",
      apply: "Apply Now!"
    },

    // Application Modal
    applicationModal: {
      title: "Application Form",
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone Number",
      email: "Email",
      instagram: "Instagram Account (Optional)",
      twitter: "Twitter Account (Optional)",
      reddit: "Reddit Account (Optional)",
      agreeTerms: "I have read and agree to the (",
      privacyPolicy: "Privacy Policy",
      submit: "Apply",
      submitting: "Submitting...",
      success: "Your application has been received successfully! We will contact you as soon as possible.",
      error: "An error occurred while submitting the application. Please try again.",
      close: "Close",
      // Validation messages
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      phoneRequired: "Phone number is required",
      phoneInvalid: "Please enter a valid phone number",
      emailRequired: "Email is required",
      emailInvalid: "Please enter a valid email address",
      instagramInvalid: "Please enter a valid Instagram username",
      twitterInvalid: "Please enter a valid Twitter username",
      redditInvalid: "Please enter a valid Reddit username",
      termsRequired: "You must accept the privacy policy"
    },

    // Footer
    footer: {
      description: "Turkey's leading OnlyFans agency. We provide professional services to maximize the success of our models.",
      quickLinks: "Quick Links",
      services: "Our Services",
      newsletter: "Newsletter",
      newsletterText: "Get information about new opportunities and updates.",
      newsletterPlaceholder: "Your email address",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      dmca: "DMCA",
      copyright: "All rights reserved."
    },

    // Language Switcher
    languageSwitcher: {
      tr: "Türkçe",
      en: "English"
    },

    // Models Section
    modelsSection: {
      heading: "Our Successful Models",
      description: "Meet our valuable models who write success stories with our agency. Each of them has achieved financial freedom by specializing in their own field.",
      clickHint: "View Details"
    },

    // Model Detail Modal
    modelDetailModal: {
      title: "Model Profile",
      about: "About",
      experience: "Experience (Months)",
      followers: "Followers",
      rating: "Rating",
      achievements: "Achievements",
      earningsPerformance: "Earnings Performance",
      monthlyEarnings: "Monthly Earnings",
      totalEarnings: "Total Earnings",
      growthRate: "Growth Rate",
      socialMediaPlatforms: "Social Media & Platforms",
      viewOnlyFansProfile: "View OnlyFans Profile",
      activeModel: "Active Model"
    },

    // About Modal
    aboutModal: {
      title: "About Us",
      closeLabel: "Close modal",
      subtitle: "Turkey's most reliable OnlyFans agency",
      description: "As MrsFans Agency, we provide comprehensive support to models who want to be successful on the OnlyFans platform. Our agency, which has been operating in the sector since 2021, helps countless models achieve financial freedom.",
      successfulModels: "Successful Models",
      totalRevenue: "Total Revenue",
      customerSatisfaction: "Customer Satisfaction",
      supportService: "Support Service",
      whatWeOffer: "What Do We Offer?",
      professionalManagement: "Professional Management",
      professionalManagementDesc: "We professionally manage your account with our experienced team.",
      contentProduction: "Content Production",
      contentProductionDesc: "We grow your audience with creative and quality content.",
      marketingStrategy: "Marketing Strategy",
      marketingStrategyDesc: "We maximize your revenues with targeted marketing.",
      dmcaProtection: "DMCA Protection",
      dmcaProtectionDesc: "We protect your content against illegal sharing.",
      mission: "Our Mission",
      missionText: "To discover each model's unique potential and provide all necessary support to bring this potential to the highest level. We aim to be the leader in the sector with our reliable, transparent and result-oriented service approach.",
      values: "Our Values",
      reliability: "Reliability",
      transparency: "Transparency",
      successOriented: "Success Oriented",
      customerSatisfactionValue: "Customer Satisfaction",
      applyNow: "Apply Now"
    },

    // Service Detail Modal
    serviceDetailModal: {
      serviceDescription: "Service Description",
      featuresAdvantages: "Features & Advantages",
      benefitsWeProvide: "Benefits We Provide",
      processMethodology: "Process & Methodology",
      performanceStats: "Performance Statistics",
      wantThisService: "Do You Want This Service?",
      applyNowDesc: "Apply now and meet our professional team!",
      applyNow: "Apply Now"
    },

    // Models Data
    models: [
      {
        name: 'Lure',
        image: '/assets/models/Alara.jpg',
        description: 'Our successful model who has been working with our agency for 2 years. Has 50K+ follower audience on social media.',
        bio: 'Experienced model who stands out with fashion and lifestyle content. Attracts attention with strong social media presence and high engagement rates. Known for creativity and professionalism in content production.',
        stats: {
          experience: '24',
          followers: '50K+',
          rating: '4.9'
        },
        achievements: [
          {
            icon: 'fas fa-star',
            title: 'Top Performer',
            description: 'Highest income performance for 6 consecutive months'
          },
          {
            icon: 'fas fa-users',
            title: 'Social Media Expert',
            description: '50K+ organic followers on Instagram'
          },
          {
            icon: 'fas fa-trophy',
            title: 'Premium Creator',
            description: 'Award in special content category'
          },
          {
            icon: 'fas fa-heart',
            title: 'Fan Favorite',
            description: '98% customer satisfaction rate'
          }
        ],
        earnings: {
          monthly: '$45K',
          total: '$850K+',
          growth: '+185%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/alara_model',
          twitter: 'https://twitter.com/alara_model',
          tiktok: 'https://tiktok.com/@alara_model',
          onlyfans: 'https://onlyfans.com/alara_model'
        }
      },
      {
        name: 'Riven',
        image: '/assets/models/Gamze.jpg',
        description: 'Our experienced model with professional photography background. Monthly income 25K+.',
        bio: 'Expert in content quality thanks to professional photography background. Enchants followers with aesthetic visuals and artistic approach. Also successful in brand collaborations.',
        stats: {
          experience: '18',
          followers: '35K+',
          rating: '4.8'
        },
        achievements: [
          {
            icon: 'fas fa-camera',
            title: 'Photography Expert',
            description: 'Professional photography certification'
          },
          {
            icon: 'fas fa-chart-line',
            title: 'Consistent Growth',
            description: 'Continuous growth in the last 12 months'
          },
          {
            icon: 'fas fa-handshake',
            title: 'Brand Partner',
            description: 'Collaboration with 10+ brands'
          },
          {
            icon: 'fas fa-gem',
            title: 'Quality Creator',
            description: 'High quality content production'
          }
        ],
        earnings: {
          monthly: '$32K',
          total: '$580K+',
          growth: '+142%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/gamze_model',
          twitter: 'https://twitter.com/gamze_model',
          tiktok: 'https://tiktok.com/@gamze_model',
          onlyfans: 'https://onlyfans.com/gamze_model'
        }
      },
      {
        name: 'Sirel',
        image: '/assets/models/Aysun.jpg',
        description: 'Our active model who stands out with fitness and healthy lifestyle content.',
        bio: 'Expert in fitness and wellness. Inspires followers who adopt a healthy lifestyle. Also includes training videos and nutrition advice in content.',
        stats: {
          experience: '15',
          followers: '28K+',
          rating: '4.7'
        },
        achievements: [
          {
            icon: 'fas fa-dumbbell',
            title: 'Fitness Expert',
            description: 'Certified fitness trainer'
          },
          {
            icon: 'fas fa-apple-alt',
            title: 'Wellness Guru',
            description: 'Nutrition and life coach'
          },
          {
            icon: 'fas fa-medal',
            title: 'Health Ambassador',
            description: 'Health and Life Consultant'
          },
          {
            icon: 'fas fa-fire',
            title: 'Motivation Master',
            description: 'High motivation content'
          }
        ],
        earnings: {
          monthly: '$28K',
          total: '$420K+',
          growth: '+156%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/aysun_fitness',
          twitter: 'https://twitter.com/aysun_fitness',
          tiktok: 'https://tiktok.com/@aysun_fitness',
          onlyfans: 'https://onlyfans.com/aysun_fitness'
        }
      },
      {
        name: 'Thais',
        image: '/assets/models/Ilgü.jpg',
        description: 'One of our young talents who attracts attention with creative content and unique style.',
        bio: 'Appeals to followers in her age group with her young and dynamic personality. Stands out with creative content ideas and trend-catching ability. Successfully reflects her unique style on social media.',
        stats: {
          experience: '12',
          followers: '42K+',
          rating: '4.9'
        },
        achievements: [
          {
            icon: 'fas fa-lightbulb',
            title: 'Creative Mind',
            description: 'Most creative content producer'
          },
          {
            icon: 'fas fa-trending-up',
            title: 'Trend Setter',
            description: 'Viral content production expert'
          },
          {
            icon: 'fas fa-rocket',
            title: 'Rising Star',
            description: 'Fastest growing model'
          },
          {
            icon: 'fas fa-paint-brush',
            title: 'Style Icon',
            description: 'Unique style and aesthetic'
          }
        ],
        earnings: {
          monthly: '$38K',
          total: '$460K+',
          growth: '+210%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/ilgu_creative',
          twitter: 'https://twitter.com/ilgu_creative',
          tiktok: 'https://tiktok.com/@ilgu_creative',
          onlyfans: 'https://onlyfans.com/ilgu_creative'
        }
      },
      {
        name: 'Nyrelle',
        image: '/assets/models/Eda.jpg',
        description: 'Our professional model who is an expert in her field at our agency.',
        bio: 'Professional with years of modeling experience. Has participated in various projects, one of our established models with experienced approach. Also provides mentoring.',
        stats: {
          experience: '30',
          followers: '32K+',
          rating: '4.8'
        },
        achievements: [
          {
            icon: 'fas fa-graduation-cap',
            title: 'Mentor',
            description: 'Mentoring service for new models'
          },
          {
            icon: 'fas fa-crown',
            title: 'Veteran',
            description: '2+ years of successful career'
          },
          {
            icon: 'fas fa-shield-alt',
            title: 'Reliable',
            description: 'Reliable and consistent performance'
          },
          {
            icon: 'fas fa-star',
            title: 'Professional',
            description: 'Professional approach and experience'
          }
        ],
        earnings: {
          monthly: '$35K',
          total: '$720K+',
          growth: '+95%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/eda_professional',
          twitter: 'https://twitter.com/eda_professional',
          tiktok: 'https://tiktok.com/@eda_professional',
          onlyfans: 'https://onlyfans.com/eda_professional'
        }
      },
      {
        name: 'Auren',
        image: '/assets/models/Irem.jpg',
        description: 'One of our most successful models. Exceeded 40K income target in 6 months.',
        bio: 'Talented model who achieved great success in a short time. Determined and persistent in exceeding goals. Attracts attention with analytical approach and strategy development ability.',
        stats: {
          experience: '8',
          followers: '38K+',
          rating: '4.9'
        },
        achievements: [
          {
            icon: 'fas fa-target',
            title: 'Goal Crusher',
            description: 'Exceeded goals by 150%'
          },
          {
            icon: 'fas fa-bolt',
            title: 'Fast Track',
            description: 'Record breaking in 6 months'
          },
          {
            icon: 'fas fa-chart-bar',
            title: 'Data Driven',
            description: 'Analytical approach expert'
          },
          {
            icon: 'fas fa-diamond',
            title: 'Top Tier',
            description: 'Top tier performance'
          }
        ],
        earnings: {
          monthly: '$52K',
          total: '$320K+',
          growth: '+280%'
        },
        socialLinks: {
          instagram: 'https://instagram.com/irem_success',
          twitter: 'https://twitter.com/irem_success',
          tiktok: 'https://tiktok.com/@irem_success',
          onlyfans: 'https://onlyfans.com/irem_success'
        }
      }
    ]
  }
}; 